import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnpin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUnpin2"><Path d="M8.5 5V2.5H15.5V8.86621C17.8786 10.1238 19.5 12.6222 19.5 15.5H18M9 8.6L8.5 8.86621C6.12136 10.1238 4.5 12.6222 4.5 15.5H16" stroke="currentColor"/><Path d="M11.5 20.5V15.5001L12.5 15.5V20.5L12 22.0001L11.5 20.5Z" fill="currentColor"/><Path d="M3 2L20 20" stroke="currentColor"/></CentralIconBase>;
});

export default IconUnpin2;
